<template>
  <div>
    <v-navigation-drawer :mini-variant-width="72" :permanent="!isMobile"
      :temporary="isMobile" v-model="drawerProxy"
      :mini-variant="isMobile ? false : minimizedDrawerProxy" v-if="permissionsLoaded"
      class="app-drawer px-2" :class="{ 'px-4 py-4': !minimizedDrawerProxy }" app
      color="plusBackground"
      :width="isMobile ? '100%' : 248" elevation="0">

      <!-- Header -->
      <v-card-actions class="mb-3 flex-row justify-center"
        @click.stop="!isMobile && toggleMiniDrawer()">
        <img @click.stop="toggleMiniDrawer" :src="assets('logos/admin-logo-pixelated.png')" class="clickable"
          alt="BJJLINK" width="60px" height="60px" />
        <v-toolbar-title class="app-title clickable font-roboto font-weight-medium headline">
          Admin+
        </v-toolbar-title>
      </v-card-actions>

      <v-btn icon size="large" @click.stop="closeDrawerMobile" aria-label="Close drawer"
        v-if="isMobile" class="close-icon">
        <v-icon size="36" color="plusTextPrimary">mdi-close</v-icon>
      </v-btn>

      <!-- Academy Selector -->
      <v-list-item @click.stop="minimizedDrawerProxy = false"
        class="mb-3 academy-selector"
        :class="isMobile ? 'mx-8' : 'mx-4'">

        <!-- <v-btn icon class="drawer-toggle-btn" size="large" @click.stop="toggleMiniDrawer" :aria-label="minimizedDrawer
      ? 'Expand drawer'
      : 'Minimize drawer'">
      <v-icon size="28">mdi-chevron-left</v-icon>
    </v-btn> -->

        <v-list-item-avatar size="36">
          <ImageDisplay v-if="$store.state.academyImage" :src="$store.state.academyImage" />
          <v-icon v-else>mdi-karate</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-roboto text-caption">
            <v-list-item-subtitle class="plusGreyDarken1--text">Academy</v-list-item-subtitle>
            <AcademySelectPlus></AcademySelectPlus>
          </v-list-item-title>
        </v-list-item-content>
        <v-icon size="20" color="plusTextSecondary">mdi-chevron-down</v-icon>
      </v-list-item>

      <v-list dense class="text-left">
        <!-- Navigation Items -->
        <NavItem v-for="item in visibleNavItems" :key="item.routeName || item.id" :icon="item.icon"
          :title="String(item.title)" :route-name="item.routeName" :route-names="item.routeNames"
          :badge="item.badge ? $store.state[item.badge] : null" @click="handleNavItemClick(item)"
          @navigate="handleNavigate" :minimized-drawer="minimizedDrawerProxy" :data-v-step="item.data_step" />
      </v-list>

      <v-card class="pa-6 mb-3" flat :color="theme.trialCard"
        v-if="(!minimizedDrawerProxy || isMobile) && showUpgradeCard">
        <div class="d-flex align-center justify-center mb-4">
          <v-img class="mr-2" :class="{ 'icon-invert': theme.dark }"
            :src="require('@/assets/icons/admin+/workspace_premium.svg')" width="20" height="20"
            max-width="20" contain />
          <div class="font-roboto font-weight-medium" style="font-size: 0.875rem;">{{
            $t("message.admin_plus_upgrade_now")
            }}</div>
        </div>
        <div class="text-center pa-0">
          <div v-if="isTrial" class="font-roboto text-caption font-weight-regular text-center">{{ trialEndsMessage }}</div>
          <v-btn text type="button"
            class="font-roboto text-caption font-weight-medium text-decoration-underline text-none"
            :color="theme.upgradeButton" @click="goToUpgradePlan">{{ $t("message.admin_plus_keep_full_access") }}</v-btn>
        </div>
      </v-card>

      <!-- Footer -->
      <v-footer v-if="!minimizedDrawerProxy || isMobile" class="plusSurface alignself py-0">
        <v-card-text class="text-center d-flex align-center justify-center flex-column py-3">
          <div class="plusGreyLighten1--text text-caption font-weight-regular mb-2">{{ $t("message.powered_by") }}</div>
          <v-img class="mat-logo" :src="require('@/assets/icons/admin+/martial-arts-technology.svg')" height="30" contain />
          <!-- TEST -->
          <!-- <div class="mt-4 d-flex flex-column test-buttons">
          <v-btn small color="primary" class="mb-2" block @click="$emit('show-welcome-dialog')">Welcome Dialog</v-btn>
          <v-btn small color="secondary" class="mb-2" block @click="$emit('show-migration-dialog')">Migration
            Dialog</v-btn>
          <v-btn small color="success" block @click="$emit('start-onboarding')">Start Onboarding</v-btn>
        </div> -->
          <!-- TEST -->
        </v-card-text>
      </v-footer>
      <!-- <div v-else class="text-center mb-3">
      <IconBjjlink style="margin-left: -12px" :size="'25pt'" :color="darkTheme ? 'white' : 'black'"></IconBjjlink>
    </div> -->
    </v-navigation-drawer>
  </div>
</template>

<style scoped>
.academy-selector {
  border-radius: 4px;
  border: 1px solid var(--v-plusBorder-base) !important;
  min-height: 53px !important;
  height: 53px !important;
}

.mat-logo {
  filter: none;
  transition: filter 0.2s;
}

.test-buttons {
  border: 2px solid #ff4444;
  border-radius: 8px;
  padding: 12px;
  background-color: rgba(255, 68, 68, 0.05);
}

.drawer-toggle-btn {
  position: absolute;
  right: -14px;
  bottom: 0;
  z-index: 9999;
  border: 1px solid var(--grey-lighten-3, #EEE);
}

@media (max-width: 960px) {
  .app-drawer {
    width: 100% !important;
    max-width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .app-drawer::v-deep .v-navigation-drawer__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 9999;
}

.app-drawer::v-deep .v-navigation-drawer__border {
  display: none;
}
</style>

<script>
// @ts-nocheck
// import IconBjjlink from "@/components/displays/icons/IconBjjlink.vue";
import AcademySelectPlus from "@/components/inputs/AcademySelectPlus.vue";
import NavItem from "./AdminPlusNavItem.vue";

export default {
  name: "AppDrawer",
  components: {
    AcademySelectPlus,
    // IconBjjlink,
    NavItem,
  },
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
    minimizedDrawer: {
      type: Boolean,
      default: true,
    },
    permissionsLoaded: {
      type: Boolean,
      default: false,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    theme() {
      const dark = this.$vuetify.theme.dark;
      return {
        dark,
        trialCard: dark ? 'plusGreyDarken3' : 'plusGrey40',
        upgradeButton: dark ? '#8C9EFF' : 'plusIndigoDarken1',
      };
    },
    showUpgradeCard(){
      const isUserAdminPlus = this.$store.state.academyAdminStatus?.settings?.isUserAdminPlus;
      const isTrial = this.$store.state.academyAdminStatus && this.$store.state.academyAdminStatus.isTrial;
      const statusConsideredActive = ["active", "trialing"];
    
      const statusStripe = this.$store.state.academyAdminStatus?.activeSubscription?.stripe?.status || "invalid";
      return isUserAdminPlus && (isTrial || !statusConsideredActive.includes(statusStripe));
    },
    drawerProxy: {
      get() {
        return this.drawer;
      },
      /** @param {boolean} value */
      set(value) {
        this.$emit("update:drawer", value);
      },
    },
    minimizedDrawerProxy: {
      get() {
        return this.minimizedDrawer;
      },
      /** @param {boolean} value */
      set(value) {
        this.$emit("update:minimizedDrawer", value);
        // Backwards-compatible alias used previously in this component.
        this.$emit("update:minimized", value);
      },
    },
    trialDaysRemaining() {
      const raw = this.$store.state.academyAdminStatus?.subscriptionEndsAt;
      if (!raw) return null;
      const end = new Date(raw);
      if (Number.isNaN(end.getTime())) return null;
      const now = new Date();
      const startToday = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
      );
      const endDay = new Date(
        end.getFullYear(),
        end.getMonth(),
        end.getDate(),
      );
      return Math.max(
        0,
        Math.round(
          (endDay.getTime() - startToday.getTime()) / (1000 * 60 * 60 * 24),
        ),
      );
    },
    trialEndsMessage() {
      const days = this.trialDaysRemaining;
      if (days === null) {
        return this.$t("message.admin_plus_trial_ends_fallback");
      }
      if (days <= 0) {
        return this.$t("message.admin_plus_trial_ends_today");
      }
      if (days === 1) {
        return this.$t("message.admin_plus_trial_ends_one_day");
      }
      return this.$t("message.admin_plus_trial_ends_in_days", { days });
    },
    navItems() {
      const isUserAdminPlus = this.$store.state.academyAdminStatus?.settings?.isUserAdminPlus;
      let shouldShowGettingStarted = false;

      if (isUserAdminPlus) {
        shouldShowGettingStarted = this.$store.state.isOnboardingUser;
      }

      return [
        {
          id: "home",
          icon: "mdi-home-outline",
          titleKey: "message.home",
          routeName: shouldShowGettingStarted ? "academysetup" : "home",
          routeNames: ["home", "academysetup"],
          showIf: "selectedAcademyNotAll",
        },
        {
          id: "growth",
          icon: "mdi-chart-box-outline",
          titleKey: "message.growth_central",
          routeName: "growthcentral",
          routeNames: ["growthcentral", "growthcentraltab"],
          permission: "view_growth_data",
          showIf: "selectedAcademy",
        },
        {
          id: "members",
          icon: "mdi-account-group-outline",
          titleKey: "message.members",
          routeName: "members-adminplus",
          routeNames: ["members-adminplus", "members-adminplus-tab"],
          permission: "view_members_data",
          showIf: "selectedAcademyNotAll",
          data_step: "2",
        },
        {
          id: "products",
          icon: "mdi-tag-outline",
          titleKey: "message.products_memberships",
          routeName: "productsmemberships",
          routeNames: ["productsmemberships"],
          permission: "view_products",
          showIf: "selectedAcademyNotAll",
          action: "navigateToProducts",
          data_step: "4",
        },
        {
          id: "transactions",
          icon: "mdi-credit-card-outline",
          titleKey: "message.transactions",
          routeName: "transactions-adminplus",
          routeNames: ["transactions-adminplus", "transactions-adminplus-tab"],
          permission: "view_income",
          showIf: "selectedAcademyNotAll",
          data_step: "5",
        },
        {
          id: "calendar",
          icon: "mdi-calendar-month-outline",
          titleKey: "message.calendar",
          routeName: "calendar-adminplus",
          routeNames: ["calendar-adminplus", "calendar-adminplus-tab"],
          permission: "view_attendance",
          showIf: "selectedAcademyNotAll",
          data_step: "3",
        },
        {
          id: "attendance",
          icon: "mdi-calendar-check-outline",
          titleKey: "message.attendance",
          routeName: "viewattendance",
          routeNames: ["viewattendance", "viewattendancetabs"],
          permission: "view_attendance",
          showIf: "selectedAcademyNotAll",
        },

        {
          id: "syllabus",
          icon: "mdi-school-outline",
          title: "LMS",
          routeName: "syllabusbuilder",
          routeNames: ["syllabusbuilder", "syllabusbuildertab"],
          permission: "manage_syllabus",
          showIf: "selectedAcademyNotAll",
        },
        {
          id: "classnotes",
          icon: "mdi-playlist-edit",
          titleKey: "message.class_notes",
          routeName: "classnotes",
          routeNames: ["classnotes", "classnotestab"],
          showIf: "selectedAcademyNotAll",
        },
        {
          id: "waivers",
          icon: "mdi-text-box-check-outline",
          titleKey: "message.waivers_documents",
          routeName: "waivers",
          routeNames: ["waivers", "waiverstab"],
          permission: "manage_documents",
          showIf: "selectedAcademyNotAll",
        },
        {
          id: "checkins",
          icon: "mdi-map-marker-outline",
          titleKey: "message.checkins",
          routeName: "checkins",
          routeNames: ["checkins"],
          permission: "view_attendance",
          showIf: "selectedAcademyNotAll",
        },

        {
          id: "flowcharts",
          icon: "mdi-hub-outline",
          titleKey: "message.flowcharts",
          routeName: "flowcharts",
          routeNames: ["flowcharts"],
          permission: "manage_videos_flowcharts",
          showIf: "selectedAcademyNotAll",
        },
        {
          id: "videos",
          icon: "mdi-play-box-outline",
          titleKey: "message.videos",
          routeName: "videos",
          routeNames: ["videos"],
          permission: "manage_videos_flowcharts",
          showIf: "selectedAcademyNotAll",
        },
        {
          id: "academy",
          icon: "mdi-cog-outline",
          titleKey: "message.academy_info",
          routeName: "academysettings",
          routeNames: ["academysettings"],
          permission: "root",
          showIf: "selectedAcademyNotAll",
          data_step: "1",
        },
        // {
        //   id: "releases",
        //   icon: "mdi-cube-outline",
        //   titleKey: "message.releases",
        //   routeName: "releases",
        //   routeNames: ["releases"],
        //   badge: "releasesCount",
        //   itemClass: "mb-6",
        //   showIf: "selectedAcademyAndLoggedIn",
        //   action: "goToReleases",
        // },
      ];
    },
    visibleNavItems() {
      return this.navItems
        .filter((item) => this.shouldShowItem(item))
        .map((item) => ({
          ...item,
          title: item.title || this.$t(item.titleKey),
        }));
    },
  },
  mounted() {
    this.$watch(
      () => this.permissionsLoaded,
      (loaded) => {
        if (!loaded) return;
        this.$nextTick(() => { this.attachScrollListener(); });
      },
      { immediate: true }
    );
  },
  updated() {
    if (!this._scrollEl) this.attachScrollListener();
  },
  beforeDestroy() {
    if (this._scrollEl && this._scrollHandler) {
      this._scrollEl.removeEventListener('scroll', this._scrollHandler);
    }
  },
  methods: {
    toggleMiniDrawer() {
      this.minimizedDrawerProxy = !this.minimizedDrawerProxy;
    },
    closeDrawerMobile() {
      this.drawerProxy = false;
      this.minimizedDrawerProxy = true;
    },
    attachScrollListener() {
      const el = this.$el && this.$el.querySelector('.v-navigation-drawer__content');
      if (!el) return;
      this._scrollEl = el;
      let scrollTimer = null;
      this._scrollHandler = () => {
        el.classList.add('is-scrolling');
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          el.classList.remove('is-scrolling');
        }, 1200);
      };
      el.addEventListener('scroll', this._scrollHandler, { passive: true });
    },
    shouldShowItem(item) {
      const store = this.$store.state;

      // Check permission first
      if (item.permission && !this.hasPermission(item.permission)) {
        return false;
      }

      // Check show condition
      switch (item.showIf) {
        case "selectedAcademy":
          return !!store.selectedAcademy;
        case "selectedAcademyNotAll":
          return store.selectedAcademy && store.selectedAcademy !== "all";
        case "selectedAcademyAndLoggedIn":
          return store.selectedAcademy && store.isUserLoggedIn;
        default:
          return true;
      }
    },
    hasPermission(permission) {
      const permissions = this.$store.state.permissions || [];
      return permissions.includes(permission) || permissions.includes("root");
    },
    handleNavItemClick(item) {
      if (item.action) {
        this[item.action]();
      }
      this.closeNav();
    },
    handleNavigate(routeName) {
      if (routeName) {
        this.navigateTo({ name: routeName });
      }
      this.closeNav();
    },
    navigateTo(route) {
      // Delegate to parent's navigateTo method via $root
      if (this.$root.navigateTo) {
        this.$root.navigateTo(route);
      }
    },
    navigateToProducts() {
      this.navigateTo({ name: "productstabs", params: { tabId: 0 } });
    },
    goToReleases() {
      this.navigateTo({ name: "releases" });
    },
    goToUpgradePlan() {
      this.navigateTo({ name: "upgrade-plan-adminplus" });
      this.closeNav();
    },
    closeNav() {
      // Check if smaller display via parent method
      const isSmaller = this.$root.isSmallerDisplay
        ? this.$root.isSmallerDisplay()
        : false;
      if (isSmaller) {
        this.drawerProxy = false;
        this.minimizedDrawerProxy = true;
      }
    },
  },
};
</script>

<style>
.theme--dark .mat-logo,
.icon-invert {
  filter: invert(1);
}

.v-navigation-drawer .v-navigation-drawer__content {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.v-navigation-drawer .v-navigation-drawer__content::-webkit-scrollbar {
  width: 4px;
}

.v-navigation-drawer .v-navigation-drawer__content::-webkit-scrollbar-track {
  background: transparent;
}

.v-navigation-drawer .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 4px;
}

.theme--light .v-navigation-drawer .v-navigation-drawer__content.is-scrolling {
  scrollbar-color: rgba(100, 100, 100, 0.6) transparent;
}

.theme--light .v-navigation-drawer .v-navigation-drawer__content.is-scrolling::-webkit-scrollbar-thumb {
  background-color: rgba(100, 100, 100, 0.6);
}

.theme--dark .v-navigation-drawer .v-navigation-drawer__content.is-scrolling {
  scrollbar-color: rgba(97, 97, 97, 0.7) transparent;
}

.theme--dark .v-navigation-drawer .v-navigation-drawer__content.is-scrolling::-webkit-scrollbar-thumb {
  background-color: rgba(97, 97, 97, 0.7);
}
</style>
